import PropTypes from 'prop-types';
import classNames from 'clsx';
import css from './payment.module.scss';

const ErrorMessages = ({ error }) => {
  if (error && error.base) {
    return (
      <div className="row">
        <div className={classNames('col-xs-12', css.bottomErrors)}>
          <span className={css.error} data-testid="baseError">
            {error.base}
          </span>
        </div>
      </div>
    );
  }

  return null;
};

ErrorMessages.propTypes = {
  error: PropTypes.object,
};

export default ErrorMessages;
